<div class="coming-soon-wrapper">
  <h1>
    {{ pageTitle | titlecase }}
  </h1>
  <div class="coming-soon-block">
    <h2>Coming soon</h2>
  </div>
</div>
